import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const INPUT = "w-full px-4 py-3 rounded-xl border border-[#D5CCBC] bg-white text-sm text-[#1E2B1D] focus:outline-none focus:ring-2 focus:ring-[#3D5A40]";
const LABEL = "block text-xs font-bold uppercase tracking-wider text-[#354634] mb-2";

export default function RecoverForm({ onBack, formatErr }) {
  const [form, setForm] = useState({ email: "", code: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password !== form.confirm) {
      setError("Konfirmasi kata sandi tidak sama");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/recover", { email: form.email, code: form.code, new_password: form.new_password });
      localStorage.setItem("puspita_admin_token", data.token);
      toast.success(`Kata sandi diatur ulang. Sisa kode pemulihan: ${data.remaining_codes}`);
      navigate("/admin/settings");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="admin-recover-form">
      <p className="text-xs text-[#5E6D5B] bg-[#F4EFE6] rounded-lg px-3 py-2">
        Masukkan salah satu <span className="font-semibold">kode pemulihan</span> yang Anda simpan dari Pengaturan Toko. Kode hanya berlaku satu kali.
      </p>
      <div>
        <label className={LABEL}>Email Admin</label>
        <input type="email" required value={form.email} onChange={set("email")} data-testid="recover-email-input" className={INPUT} />
      </div>
      <div>
        <label className={LABEL}>Kode Pemulihan</label>
        <input required value={form.code} onChange={set("code")} data-testid="recover-code-input" placeholder="XXXX-XXXX-XXXX" className={`${INPUT} font-mono uppercase tracking-widest`} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className={LABEL}>Kata Sandi Baru</label>
          <input type="password" required minLength={8} value={form.new_password} onChange={set("new_password")} data-testid="recover-new-password-input" className={INPUT} />
        </div>
        <div>
          <label className={LABEL}>Konfirmasi</label>
          <input type="password" required value={form.confirm} onChange={set("confirm")} data-testid="recover-confirm-input" className={INPUT} />
        </div>
      </div>
      {error && (
        <p data-testid="recover-error" className="text-xs text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</p>
      )}
      <button type="submit" disabled={loading} data-testid="recover-submit" className="w-full py-3.5 rounded-xl bg-[#3D5A40] hover:bg-[#2E4530] disabled:opacity-50 text-[#FAF7EE] font-bold text-sm transition-colors shadow-md">
        {loading ? "Memproses..." : "Atur Ulang Kata Sandi"}
      </button>
      <button type="button" onClick={onBack} data-testid="recover-back-btn" className="w-full text-xs text-[#6B7C66] hover:text-[#3D5A40] transition-colors">
        ← Kembali ke login
      </button>
    </form>
  );
}
